import * as I18n from 'circe/I18n';

export const MANIFEST_TYPES = {
  STATIC: {
    value: 'STATIC',
    label: I18n.str('static', 'Static'),
  },
  DYNAMIC: {
    value: 'DYNAMIC',
    label: I18n.str('dynamic', 'Dynamic'),
  },
};

export const ROUTES = {
  ROOT: '/manifest/:code/receive',
};

export const ENDPOINTS = {
  MANIFEST_DETAILS_BY_CODE: `${OPERATIONS_EDGE}/api/manifest/by-manifest-code/{code}`,
  RECEIVE_MANIFEST: `${OPERATIONS_EDGE}/api/manifests/receive`,
  RECEIVE_MANIFEST_WAYBILLS: `${OPERATIONS_EDGE}/api/manifests/receive/waybills`,
  DOWNLOAD_REPORT: `${SHIPPING_EDGE}/api/manifest/{manifestId}/download-manifest-report`,
};
